module.exports = __webpack_public_path__ + "img/advantage2.9fe86d41.svg";